import { get, put } from './transport.js';
/** `GET /api/intelligence/settings` (needs `org:manage`). */
export async function read(options) {
    return get('/api/intelligence/settings', options);
}
/** `PUT /api/intelligence/settings` — replaces the whole set (needs `org:manage`). */
export async function save(settings, options) {
    return put('/api/intelligence/settings', { settings }, options);
}
//# sourceMappingURL=intelligenceSettings.js.map